import {
  PencilIcon,
  TrashIcon,
  NoSymbolIcon,
} from "@heroicons/react/24/outline";
import { Button } from "@/components/ui/Button";

type ActionButtonsProps = {
  onEdit?: () => void;
  onDelete?: () => void;
  onEndNow?: () => void;
  showEndNow?: boolean;
  className?: string;
};

/**
 * Standardized action buttons for CRUD operations
 * This component provides consistent styling and behavior for action buttons across features
 */
const ActionButtons: React.FC<ActionButtonsProps> = ({
  onEdit,
  onDelete,
  onEndNow,
  showEndNow = false,
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col lg:flex-row justify-end gap-1 lg:gap-2 w-full ${className}`}
    >
      {onEdit && (
        <Button
          variant="outline"
          size="sm"
          onClick={onEdit}
          className="text-white75 hover:text-white border-white75 hover:border-white"
        >
          <PencilIcon className="size-4 mr-2" /> Edit
        </Button>
      )}

      {showEndNow && onEndNow && (
        <Button
          variant="outline"
          size="sm"
          onClick={onEndNow}
          className="text-white75 hover:bg-red-500 border-white75 hover:border-white"
        >
          <NoSymbolIcon className="size-4 mr-2" /> End Now
        </Button>
      )}

      {onDelete && (
        <Button
          variant="outline"
          size="sm"
          onClick={onDelete}
          className="bg-red-600 hover:bg-red-500 text-white75 hover:text-white border-red20 hover:border-red-500"
        >
          <TrashIcon className="size-4 mr-2" /> Delete
        </Button>
      )}
    </div>
  );
};

export default ActionButtons;
